import React from 'react';
import RowHeaderHelp from '../../components/RowHeaderHelp';
import UserTabs from '../../components/molecules/configuration/users/screens';

import FormCreatePrivateDrivers from '../../components/molecules/configuration/privateDrivers/createDrivers';
import { useStyles } from '../../services/material-ui';
import { Drawer } from '../../components';

const CreatePrivateDriver: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormCreatePrivateDrivers />
      </main>
    </div>
  );
};

export default CreatePrivateDriver;
